module.exports = __webpack_public_path__ + "static/sport/dang-ky-nhan.0411867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/dang-ky-nhan.png
// module id = k1fy
// module chunks = 0